<template>
    <nav>
      <ul>
        <li>
            <a href="#" @click.prevent="navigateTo('Home')">Home</a>
        </li>
        <li>
            <a href="#" @click.prevent="navigateTo('Home')">Support
                <svg style="margin-left: 5px;" viewBox="0 0 1030 638" width="10">
                    <path d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z" fill="#FFF"></path>
                </svg>
            </a>

            <ul>
              <li><a href="#" @click.prevent="navigateTo('clearUserData')">User Data</a></li>
              <li><a href="#" @click.prevent="navigateTo('usageTermsEn')">Terms of Usage</a></li>
              <li><a href="#" @click.prevent="navigateTo('about')">Contact Us</a></li>
            </ul>
        </li>
        <li>
          <a href="#" @click.prevent="navigateTo('Home')">About</a>
        </li>
      </ul>
    </nav>
  </template>
  
  <script>
  export default {
    methods: {
      navigateTo(routeName) {
        this.$router.push({ name: routeName });
      }
    }
  };
  </script>
  
  <style scoped>

  nav {
    background-color: #555;
    height: 30px;
    padding: 5px 0px 30px 0px;
  }

  nav ul {
    list-style-type: none;
    padding: 0;
  }
  
  nav ul li {
    padding: 10px 0px;
    width: 150px;
    position: relative;
    display: inline-block;
    border-bottom: 3px solid transparent;
    
  }
  
  nav ul li ul {
    width: 150px;
    display: none;
    position: absolute;
    color: #FFF;
    top: 100%;
    left: 0;
    z-index: 10;
    background-color: #555;
    border-radius: 0px 0px 8px 8px;
    margin-top: 1.5px;

  }
  
  nav > ul> li:hover {
    background-color: #666;
    border-bottom-color: #58d0ff;
  }
  
  nav > ul> li > ul li:hover {
    background-color: #666;
    border-bottom-color: #58d0ff;
  }

  nav ul li:hover ul {
    display: block;
  }
  
  nav ul li a {
    text-decoration: none;
    padding: 10px;
    display: block;
    color: #FFF;
  }
  </style>
  